export default "__VITE_ASSET__BBKYNr0Z__"